export const WELCOME = {
  nameInput: 'welcome-name-input',
  startButton: 'welcome-start-button',
  container: 'welcome-container'
};

export const HEADER = {
  container: 'header-container',
  title: 'header-title',
  studentName: 'header-student-name',
  dateTime: 'header-date-time'
};

export const DASHBOARD = {
  container: 'dashboard-container',
  lessonCard: (id) => `lesson-card-${id}`,
  startButton: (id) => `lesson-start-button-${id}`
};

export const LESSON = {
  container: 'lesson-container',
  problemPanel: 'lesson-problem-panel',
  codePanel: 'lesson-code-panel',
  visualizationPanel: 'lesson-visualization-panel',
  arrayInput: 'lesson-array-input',
  targetInput: 'lesson-target-input',
  loadButton: 'lesson-load-button',
  playButton: 'lesson-play-button',
  pauseButton: 'lesson-pause-button',
  nextButton: 'lesson-next-button',
  prevButton: 'lesson-prev-button',
  restartButton: 'lesson-restart-button',
  randomButton: 'lesson-random-button',
  resetButton: 'lesson-reset-button',
  speedControl: 'lesson-speed-control',
  arrayCell: (index) => `array-cell-${index}`,
  pointer: (type) => `pointer-${type}`,
  completionScreen: 'lesson-completion-screen',
  backToDashboard: 'lesson-back-to-dashboard'
};

export const FOOTER = {
  container: 'footer-container',
  copyright: 'footer-copyright',
  subtitle: 'footer-subtitle'
};

export const HOME = {
  emergentLink: 'home-emergent-link'
};
